import { makeEntityScaffold } from '@classpass/saga-tools';
import { FitnessTrends } from 'derivers/FitnessTrends';
var KEY = 'SAGA.API.FITNESS_TRENDS';
export var fitnessTrendsMember = makeEntityScaffold("".concat(KEY, ".GET_MEMBER"), function (client, year, memberHash) {
  return client.statics.fitnessTrendsMember(year, memberHash).then(function (data) {
    return FitnessTrends.member(data);
  });
});